module.exports = __webpack_public_path__ + "static/media/QandA.abc9c2bb.docx";